import React, { useRef, useEffect } from 'react';
import ThreePointLayer from './ThreePointLayer';
import { useUpdateEffect } from 'ahooks';
import { registerEventLayer } from '../events';
import useProps from '../_util/useProps';

export default function(props) {
    const {
        data,
        features,
        url,
        params,
        zIndex,
        id: key,
        _key,
        name,
        style,
        labelField,
        template,
        show = true,
        groupLayer,
        legend,
        height,
        color,
        speed,
        width,
        flyWidth,
        layerControl = true,
        number,
        glowPower,
    } = props;
    const layerRef = useRef();
    const { map } = useProps();

    useEffect(() => {
        let layer = new ThreePointLayer({
            data,
            features,
            url,
            params,
            style,
            zIndex,
            key: key || _key,
            name,
            labelField,
            template,
            show,
            legend,
            height,
            color,
            speed,
            map,
            groupLayer,
            width,
            flyWidth,
            layerControl,
            number,
            glowPower,
        });

        // 注册事件
        layer.loaded = (primitives) => {
            primitives.forEach((item) => {
                registerEventLayer(item, props);
            })
        }

        layerRef.current = layer;
        return () => {
            layerRef.current.destroy()
        };
    }, []);

    useUpdateEffect(() => {
        layerRef.current.loadData(data);
    }, [JSON.stringify(data)]);

    useUpdateEffect(() => {
        layerRef.current.show = show;
    }, [show]);

    return <></>;
}
